"use client";

import { useState } from "react";

import FacilityPicker from "@components/ui/facility-picker";
import { facilities, getFacilityBySlug } from "@/data/facilities";
import ContactForm from "./contact-form";
import FacilityMap from "../../app/(main)/anlaggningar/facility-map";

const activeFacilities = facilities.filter((f) => f.status === "active");

/** Kontakt page: pick a facility, then the form + "Besök oss" map follow it. */
const ContactSection = () => {
	const [slug, setSlug] = useState(activeFacilities[0]?.slug ?? "norrkoping");
	const facility = getFacilityBySlug(slug) ?? activeFacilities[0];

	return (
		<div className="space-y-16">
			<div className="max-w-5xl mx-auto">
				<FacilityPicker value={slug} onChange={setSlug} label="Vilken anläggning vill du kontakta?" />
			</div>

			<ContactForm facility={facility} />

			{/* Besök oss — reflects the selected facility */}
			<div>
				<div className="flex flex-col items-center text-center mb-6">
					<h2>Besök oss i {facility.name}</h2>
					<p className="text-gray-400 text-sm mt-1">
						{facility.address}, {facility.zipCity}
					</p>
				</div>
				<div className="rounded-xl overflow-hidden h-[400px] border border-white/[0.06]">
					<FacilityMap
						latitude={facility.coordinates.latitude}
						longitude={facility.coordinates.longitude}
						label={`${facility.address}, ${facility.zipCity}`}
					/>
				</div>
			</div>
		</div>
	);
};

export default ContactSection;
